import { useNavigate } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui';

import { meetingStore } from '../meetings.state';

import type { MeetingId } from '../meetings.types';

export const TranscriptGotoButton = observer(
  ({ meetingId }: { meetingId: MeetingId }) => {
    const navigate = useNavigate();
    const isRecordingThisMeeting = meetingStore.isMeetingIdRecording(meetingId);

    const handleToggle = () => {
      meetingStore.closeTranscriptPopover();
      navigate({
        to: '/meetings/$meetingId',
        params: { meetingId: meetingId.toString() },
        search: { tab: isRecordingThisMeeting ? 'notes' : 'summary' },
      });
    };

    return (
      <IconButton
        icon={Icons.goToIcon}
        size="xs"
        variant="ghost"
        onClick={handleToggle}
        strokeWidth={1.6}
      />
    );
  }
);
